<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Update Excel Sample
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.model_name"
                outlined
                label="Module"
                prepend-inner-icon="mdi-card-text-outline"
                @input="form.model_name = form.model_name.toUpperCase()"
                :error-messages="errors.model_name"
              ></v-text-field>
            </v-col>
            <v-col>
              <input
                type="file"
                id="document"
                name="document"
                ref="document"
                accept=".xls,.xlsx"
                @input="handleFileUpload"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Excel Sample
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "ExcelSampleEditPage",
  data() {
    return {
      form: {
        model_name: "",
      },
      excel_samples: [],
      userItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.sampleId;
      axios
        .get(`/samples/${encryptedId}`)
        .then(async (response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
      console.log("this.form:", this.form);
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.patch(`/samples/${this.$route.params.sampleId}`, this.form);
        await this.handleFileUpload();
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
      this.$router.back();
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/sample-excels/${this.form.id}`,
          from_name: "ExcelSampleEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        // this.$router.push("/sample-excels");
      } catch (error) {
        console.log(error);
      }
    },
    async handleFileUpload() {
      let formData = new FormData();
      this.document_attachment = this.$refs.document.files[0];
      const formattedFilename =
        this.form.module.toLowerCase().replace(/\s+/g, "_") + "_";
      formData.append("id", this.form.id);
      formData.append("filename", formattedFilename);
      formData.append("document", this.document_attachment);
      console.log("formData", formData);
      await axios
        .post("upload_excel_sample_documents", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(() => {
          this.isError = true;
          this.error_msg =
            "Looks like system faced an error while uploading the File. Kindly check the file before uploading ...";
        });
      this.isUploading = false;
    },
  },
};
</script>
